import React from 'react';
import { CONTAINER_MODAL_ROUTES } from '@/navigators/routes';
import { ContainerModalStackParams } from '@/navigators/types.js';
import { CountryCode } from 'libphonenumber-js';
import { CountrySelector } from '@/components/country-selector';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  ContainerModalStackParams,
  CONTAINER_MODAL_ROUTES.CountrySelector
>;

export const CountrySelectorScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { initialCountryCode, onCountryCodeChange } = route.params;

  return (
    <ModalContainer>
      <CountrySelector
        initialCountryCode={initialCountryCode}
        onCountrySelect={(countryCode) => {
          onCountryCodeChange(countryCode as CountryCode);
          navigation.goBack();
        }}
      />
    </ModalContainer>
  );
};
